import { useEffect, useRef } from 'react';

type MessageHandler<T = unknown> = (payload: T) => void;

function useWorkflowEditorMessageListener<T = unknown>(type: string, callback: MessageHandler<T>) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.type === type) {
        callbackRef.current(event.data.payload);
      }
    };

    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [type]);
}

export default useWorkflowEditorMessageListener;
